import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/General/FlyoutMenu/flyoutMenu.default"
    ).then((module) => ({
        default: module.FlyoutMenuDefault
    }))
);
